import { Injectable } from '@angular/core'

@Injectable({
    providedIn: 'root'
})
export class LanguageParserService {

    constructor() {
    }


    getShortLanguage(lang?: string | null) {
        if(!lang) {
            return 'en'
        }
        if(lang.includes('-')) return lang.split('-')[0].toLowerCase()
        if(lang.includes('_')) return lang.split('_')[0].toLowerCase()
        return lang.toLowerCase();
    }
}
